import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import * as blockchainsServices from '../blockchainsServices'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const usePrefetchBlockchainsCatalogs = (currencyCodes: string[]) => {
  const queryClient = useQueryClient()

  useEffect(() => {
    // Prefetch blockchains for all currencies
    currencyCodes.forEach((currency_isin) => {
      if (currency_isin) {
        queryClient.prefetchQuery({
          queryKey: [QUERY_KEYS.CATALOGS_BLOCKCHAINS, { currency_isin }],
          queryFn: () => blockchainsServices.getBlockchains({ currency_isin }),
          staleTime: 5 * 60 * 1000, // 5 minutes
        })
      }
    })
  }, [currencyCodes, queryClient])
}
